import script from "./DashboardMembresias.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardMembresias.vue?vue&type=script&setup=true&lang=js"

import "./DashboardMembresias.vue?vue&type=style&index=0&id=e17cd2ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17cd2ea"]])

export default __exports__